<template>
  <div class="order-number">
    <ul v-for="(item, index) in records" :key="index">
      <li class="margin-b10">
        <div class="top">
          <div class="top-header-left">
            <div>订单编号：</div>
            {{ item.orderNo }}
          </div>
          <div class="top-header-right">
            <!-- <div v-if="item.orderStatusNum == '12' && item.approveRealName">
                <div >
                  <el-tooltip class="item" effect="dark"  :content="item.approveRealName" placement="top" v-if="item.approveRealName.length>2">
                    <div class="approver" >审批人：
                      <span>{{item.approveRealName}}</span>
                    </div>
                  </el-tooltip>
                  <div class="approver" v-else>审批人：
                    <span>{{item.approveRealName}}</span>
                  </div>
                </div>
              </div> -->
            <div v-if="item.systemSource == 3" class="order-status-text">
              订单来源：{{
                item.systemSource == 3
                  ? 'Mro商城'
                  : item.systemSource == 2
                  ? '易派客2.0系统'
                  : '易派客'
              }}
            </div>
            <div class="order-status-text">
              订单状态：{{
                (item.orderStatusNum == '21' || item.orderStatusNum == '22') &&
                item.paymentStatus == '3'
                  ? '付款中'
                  : item.orderStatus
              }}
              <el-tooltip class="item" effect="dark" placement="top-end" v-if="item.refuseReason">
                <div slot="content" style="width: 156px">
                  {{ `审核拒绝原因：` + item.refuseReason }}
                </div>
                <!--                  <img src="~/static/order/help-gray.png" alt="" class="img-show" >-->
                <div class="img-show"></div>
              </el-tooltip>
            </div>
            <div
              style="margin-left: 10px"
              v-if="item.orderStatusNum == '12' && item.approveRealName"
            >
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.approveRealName"
                  placement="top"
                  v-if="item.approveRealName.length > 2"
                >
                  <div class="approver">
                    (审批人：
                    <span>{{ item.approveRealName + ')' }}</span>
                  </div>
                </el-tooltip>
                <div class="approver" v-else>
                  审批人：
                  <span>{{ item.approveRealName + ')' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="middle-view">
          <div class="item-img">
            <div class="item-img-content">
              <div class="item-img-content-top" v-if="item.skuJson">
                <ul v-for="(skuList, index) in item.skuJson.skuList" v-if="index < 3" :key="index">
                  <li @click="toDetail(skuList, item.supplierCompanyId, item.orderSource)">
                    <!-- v-lazy="skuList.productPictUrl" -->
                    <img :src="skuList.productPictUrl" alt="" class="img-relative" />
                  </li>
                </ul>
                <div class="item-content">
                  <div
                    class="break min-width"
                    v-if="item.skuJson.skuList && item.skuJson.skuList.length == 1"
                    @click="
                      toDetail(item.skuJson.skuList[0], item.supplierCompanyId, item.orderSource)
                    "
                  >
                    {{ item.skuJson.skuList[0].brandName }}
                    {{ item.skuJson.skuList[0].productName }}
                  </div>
                  <div
                    class="break font"
                    v-if="
                      item.skuJson.skuList &&
                        item.skuJson.skuList.length == 1 &&
                        item.skuJson.skuList[0].displaySkuOptions &&
                        item.skuJson.skuList[0].displaySkuOptions.length < 110
                    "
                  >
                    {{ item.skuJson.skuList[0].displaySkuOptions }}
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.skuJson.skuList[0].displaySkuOptions"
                    placement="top"
                    v-if="
                      item.skuJson.skuList &&
                        item.skuJson.skuList.length == 1 &&
                        item.skuJson.skuList[0].displaySkuOptions &&
                        item.skuJson.skuList[0].displaySkuOptions.length > 110
                    "
                  >
                    <div class="break font">
                      <div class="break font">{{ item.skuJson.skuList[0].displaySkuOptions }}</div>
                    </div>
                  </el-tooltip>

                  <div
                    v-if="
                      item.skuJson.skuList &&
                        item.skuCount < 4 &&
                        (item.skuJson.skuList.length == 2 || item.skuJson.skuList.length == 3)
                    "
                  >
                    共{{ item.skuJson.skuList.length }}种商品
                  </div>
                  <div v-if="item.skuCount > 3">等 {{ item.skuCount }} 种商品</div>
                </div>
              </div>
              <div class="item-img-content-bottom">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.memberRealName"
                  placement="top"
                  v-if="item.memberRealName.length > 3"
                >
                  <span class="real-name break">下单人：{{ item.memberRealName }}</span>
                </el-tooltip>
                <span class="real-name break" v-else>下单人：{{ item.memberRealName }}</span>

                <span class="phone">联系电话：{{ item.memberMobile }}</span>
                <span class="dept break">下单部门：{{ item.orgShortName }}</span>
              </div>
            </div>
          </div>
          <div class="item-name">
            <span class="item-name-nick">供应商名称：</span>
            <span class="item-name-company">{{ item.supplierCompany }}</span>
          </div>
          <div class="item-money">
            <span class="item-money-nick">订单总额：</span>
            <span class="item-money-company">¥ {{ Number(item.needPay).toFixed(2) }}</span>
          </div>
          <div class="item-detail" v-if="item.skuJson">
            <div
              :class="{
                'is-active': underlineName == '查看订单详情' && underlineOrderId == item.orderId,
              }"
              @click="checkOrderDetail(item.orderId)"
              v-if="flags.detailFlag"
            >
              查看订单详情
            </div>
            <div
              :class="{ 'is-active': underlineName == '审批' && underlineOrderId == item.orderId }"
              v-if="isApprove(item) && item.systemSource != 3"
              @click="orderApprove(item.orderId)"
            >
              审批
            </div>
          </div>
          <div class="item-detail" v-else></div>
        </div>
        <div class="bottom-view">
          <div class="bottom-view-left" v-if="item.orderSource == 3 || item.orderSource == 31">
            <!--index页面有处理此字段-->
            采购申请号：{{ item.purchaseRequisitionNo }}
            <el-tooltip
              class="item len"
              effect="dark"
              placement="top-start"
              v-if="item.moreRequestNo"
            >
              <div
                slot="content"
                style="height: 30px; overflow-y: auto"
                :style="{ width: item.moreRequestNo.length > 26 ? '101px' : '89px' }"
              >
                {{ item.moreRequestNo }}
              </div>
              <span class="more">更多</span>
            </el-tooltip>
            <span v-if="item.sinoPoNo">ERP订单号：{{ item.sinoPoNo }}</span>
          </div>
          <div v-if="item.inquiryComparisonNo">询比价单号：{{ item.inquiryComparisonNo }}</div>
          <div class="bottom-view-left" v-else></div>
          <div class="bottom-view-right">下单时间：{{ item.submitTime }}</div>
        </div>
      </li>
    </ul>
    <div v-if="noDataFlag" class="no-data">
      <p>贵公司当前暂无{{ tipWord }}订单</p>
      <!-- <p>
        请
        <span @click="toSelect">选择商品</span>
        下单
      </p> -->
    </div>
  </div>
</template>
<script>
import utils from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/auditManagement/index';
import { mallBaseUrl } from '@/modules/projectA/api/urlConfig';
export default {
  name: 'allOrder',
  props: {
    selectOrder: {
      type: Function,
      required: true,
    },
    records: Array,
  },
  data() {
    return {
      tipWord: '',
      checkCompanyAttrFlag: false,
      underlineName: '',
      underlineOrderId: '',
      orderStatusNum: '',
      noDataFlag: false,
      formInline: {
        projectnos: null, //采购申请号 目前没有
        orderNo: null, //订单编号
        supplierCompany: null, //供应商名称
        time: null,
        startTime: null,
        endTime: null,
        memberRealName: null, //下单人姓名
        shipmentType: null, //配送方式 1：配送　　2：自提
        orderStatus: null,
        otherPay: 0, //0不使用1使用易权通
        endAmount: null,
        startAmount: null,
      },
      flags: {
        detailFlag: false, //查看订单详情
        approveFlag: false, //审批
      },
      saltLakeFlag: false,
    };
  },
  methods: {
    // 代运营订单 orderSource为5、 订单完成的单子 只允许 查看订单详情 和 打印
    handeDetalPrint(orderSource, orderStatusNum) {
      if (orderSource == 5 && orderStatusNum == 6) {
        return true;
      }
      return false;
    },

    //常态显示 发货单列表
    isReceive(item) {
      //20220-12-12如果是盐湖的计划采购订单完成审核后，收货入口去掉3和31是计划采购订单
      if (this.saltLakeFlag && (item.orderSource == 3 || item.orderSource == 31)) {
        return false;
      }

      if (this.handeDetalPrint(item.orderSource, item.orderStatusNum)) {
        return false;
      }

      if (
        (item.orderStatusNum == 4 || item.receivedQuantity != 0 || item.unReceivedQuantity != 0) &&
        item.orderStatusNum != 7 &&
        item.orderStatusNum != 72 &&
        item.orderStatusNum != 71
      ) {
        return true;
      } else {
        return false;
      }
    },
    showPayment(item) {
      //20220-12-12如果是盐湖的计划采购订单完成审核后，收货入口去掉3和31是计划采购订单
      if (this.saltLakeFlag && (item.orderSource == 3 || item.orderSource == 31)) {
        return false;
      }

      if (this.handeDetalPrint(item.orderSource, item.orderStatusNum)) {
        return false;
      }

      if (
        (item.orderStatusNum == '21' || item.orderStatusNum == '22') &&
        this.flags.payFlag &&
        item.paymentStatus != '3'
      ) {
        return true;
      }
      return false;
    },

    toSelect() {
      this.$router.push({ path: '/' });
    },
    async queryPcButton() {
      let res = await Api.queryPcButton({ authCode: '/user/user/userOrder' });
      if (res.code == '200' && res.data) {
        this.queryPcButton = res.data;
        for (let i = 0; i < this.queryPcButton.length; i++) {
          if (this.queryPcButton[i].authName == '查看订单详情') {
            this.flags.detailFlag = true;
          }
          if (this.queryPcButton[i].authName == '审核') {
            this.flags.approveFlag = true;
          }
        }
      }
    },
    toDetail(data, param, orderSource) {
      if (orderSource == 4) {
        return;
      }
      window.open(
        `${mallBaseUrl}/products/productDetail?productId=${data.productSkuId}&supplierId=${param}`,
        '_blank'
      );
    },
    //审批
    isApprove(item) {
      if (this.handeDetalPrint(item.orderSource, item.orderStatusNum)) {
        return false;
      }

      let arr = [3, 31];
      if (
        (((item.orderSource == 3 || item.orderSource == 31) &&
          item.isShowPurchaseRequestApproveButton == 1) ||
          !arr.includes(Number(item.orderSource))) &&
        this.flags.approveFlag &&
        item.isShowApproveButton == '1'
      ) {
        return true;
      }
      return false;
    },
    setUnderline(data) {
      localStorage.setItem('underlineData', JSON.stringify(data));
    },
    //查看订单详情
    checkOrderDetail(orderId) {
      this.setUnderline({ underlineName: '查看订单详情', underlineOrderId: orderId });
      window.open(
        `${mallBaseUrl}/user/user/order/orderDetailOrApprove?orderId=${orderId}&orderFlag=orderDetail&underlineName=查看订单详情`,
        '_blank'
      );
    },
    //审批
    orderApprove(orderId) {
      this.setUnderline({ underlineName: '审批', underlineOrderId: orderId });
      window.open(
        `${mallBaseUrl}/user/user/order/orderDetailOrApprove?orderId=${orderId}&orderFlag=orderApprove`,
        '_blank'
      );
    },
    //判断是不是大全
    async checkCompanyAttrValue() {
      //测试环境SAP500; 生产环境SAP800
      const userInfo = localStorage.getItem('USERINFO');
      const companyId = JSON.parse(userInfo).companyId;
      let res = await Api.checkCompanyAttrValue({
        companyAttrValue: process.env.environment == 'production' ? 'SAP800' : 'SAP500',
        companyId: companyId,
      });
      if (res.code == 200) {
        this.checkCompanyAttrFlag = res.data;
      }
    },
  },
  mounted() {
    this.queryPcButton();
    // this.checkCompanyAttrValue();
    this.underlineData = JSON.parse(localStorage.getItem('underlineData'));
    if (this.underlineData) {
      this.underlineName = this.underlineData.underlineName;
      this.underlineOrderId = this.underlineData.underlineOrderId;
    }
  },
  watch: {
    records(val) {
      // console.log(val,'订单列表')
      if (val.length == 0) {
        this.noDataFlag = true;
      } else {
        this.noDataFlag = false;
      }
    },
    $route(to) {
      switch (to.query.type) {
        case '18':
          this.tipWord = '待采购商确认';
          break;
        case '12':
          this.tipWord = '待审批';
          break;
        case '21':
          this.tipWord = '待付款';
          break;
        case '4':
          this.tipWord = '待收货';
          break;
        case '5':
          this.tipWord = '待评价';
          break;
        default:
          this.tipWord = '';
      }
      immediate: true;
    },
    isSaltLakeFlag(val) {
      this.saltLakeFlag = val;
    },
  },
  computed: {
    isSaltLakeFlag() {
      return this.$store.state.isSaltLakeFlag;
    },
  },
};
</script>
<style lang="scss">
.el-tooltip__popper {
  border-radius: 0;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.order-number {
  margin-top: 10px;
  .margin-b10 {
    margin-bottom: 10px;
  }
  .top {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    padding-right: 30px;
    background-color: #f5f5f5;
    border: 1px solid $border-color;
    //border-bottom: 1px solid $border-color;
    box-sizing: border-box;
    .top-header-left {
      color: #333333;
      font-weight: 700;
      display: flex;
    }
    .top-header-right {
      display: flex;
      justify-items: center;
      .approver {
        display: flex;
        span {
          /* width: 70px; */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .order-status-text {
        color: #333;
        display: flex;
        justify-content: center;
        align-items: center;
        .img-show {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          background: url('~@/assets/img/purchase/help-gray.png') center no-repeat;
          background-size: 18px 18px;
          &:hover {
            background: url('~@/assets/img/purchase/help-gray-active.png') center no-repeat;
            background-size: 18px 18px;
          }
        }
      }
    }
  }
  .middle-view {
    display: flex;
    align-items: center;
    padding: 20px;
    padding-right: 0;
    box-sizing: border-box;
    border: 1px solid $border-color;
    border-top: none;
    .item-img {
      .item-img-content {
        width: 489px;

        .item-img-content-top {
          display: flex;
          align-items: center;
          margin-top: -15px;
          .break {
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .font {
            font-size: 12px;
          }
          ul {
            display: flex;
            min-width: 96px;
            font-size: 14px;
            li {
              width: 88px;
              height: 88px;
              padding-top: 4px;
              line-height: 88px;
              border: 1px solid #d9d9d9;
              text-align: center;
              margin-right: 10px;
              position: relative;
              .img-relative {
                width: 76px;
                height: 76px;
              }
              .img-absolute {
                width: 20px;
                height: 25px;
                position: absolute;
                left: 6px;
                top: 0;
              }
            }
            li:nth-child(2) {
              margin: 0 10px;
            }
            li:nth-child(3) {
              margin-right: 10px;
            }
          }
        }
        .item-img-content-bottom {
          display: flex;
          margin-top: 18px;
          color: #999;
          font-size: 12px;
          .real-name {
            width: 92px;
          }
          .phone {
            width: 139px;
          }
          .dept {
            width: 236px;
          }
          .break {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span:nth-child(2) {
            margin: 0 10px;
          }
        }
      }
    }
    .item-name {
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      padding: 30px 0 0 30px;
      border-left: 1px solid $border-color;
      height: 120px;
      box-sizing: border-box;
      width: 170px;
      .item-name-nick {
        color: #999999;
        margin-bottom: 10px;
      }
    }
    .item-money {
      display: flex;
      flex-direction: column;
      margin-left: 15px;
      padding: 25px 0 0 30px;
      border-left: 1px solid $border-color;
      height: 120px;
      box-sizing: border-box;
      width: 164px;
      .item-money-nick {
        margin-bottom: 10px;
        color: #999999;
      }
      .item-money-company {
        color: #fc4948;
        font-weight: bold;
      }
    }
    .item-detail {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-left: 1px solid $border-color;
      height: 120px;
      box-sizing: border-box;
      padding-left: 10px;
      margin-left: 18px;
      width: 113px;
      text-align: center;
      font-size: 12px;
      .is-active {
        border-bottom: 1px solid #0064c8;
      }
      div {
        cursor: pointer;
        color: #0064c8;
        border-bottom: 1px solid transparent;
        &:hover,
        :active {
          color: #2782ec;
          border-bottom: 1px solid #0064c8;
        }
      }

      .active {
        color: #2782ec;
      }
    }
  }
  .bottom-view {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    border: 1px solid $border-color;
    border-top: none;

    .bottom-view-left {
      font-weight: 400;
      color: #333;
      span {
        margin-left: 40px;
      }
      .more {
        color: #2f80ed;
        margin-left: 10px;
        cursor: pointer;
      }

      ::v-deep .el-tooltip_popper {
        width: 30px;
      }
    }
    .bottom-view-right {
      font-size: 14px;
      color: #999999;
    }
  }
  .no-data {
    text-align: center;
    margin-bottom: 80px;
    img {
      margin-top: 60px;
      width: 204px;
      height: 124px;
    }
    p {
      margin-top: 10px;
      color: #333;
      font-size: 16px;
      span {
        color: #2587ff;
        cursor: pointer;
      }
    }
  }
}
</style>
